<div class="mt-3 animated fadeIn">
  <h4 id="degrees-heading">Degrees</h4>
  <ng-container *ngIf="degrees | async | sortBy: 'desc':'yearConferred' as items; else loading">
    <div class="table-responsive">
      <table class="table table-striped border mt-3 shadow-sm" [class.table-sm]="isMobile | async" aria-labelledby="degrees-heading">
        <caption class="sr-only">Degrees</caption>
        <thead>
          <tr>
            <th *ngFor="let head of degreeHeadElements" scope="col">{{head}} </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let el of items">
            <td>{{ el.name }}</td>
            <td [innerHTML]="el.discipline"></td>
            <td>{{ el.yearConferred }}</td>
            <td [innerHTML]="el.grantingInstitution"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <ngx-skeleton-loader count="10"></ngx-skeleton-loader>
</ng-template>